export default __webpack_public_path__ + "static/media/57.03b61144.png";